import React, { useEffect, useState } from "react";
import { useGetUserFaqMutation } from "../../../store/user/contentsApiSlice";
import { getCookie } from "../../../util/cookie/cookies";
import { Paginate } from "../../../components/paginate/paginate";
import { useLocation, useNavigate } from "react-router-dom";
import AnimateHeight from "react-animate-height";
interface ParamType {lang : string, page : any, size : number, keyword : string, sortOrder : string, sortColumn : string}
export const ContactFaq = () => {
    const location = useLocation()
    const page = new URLSearchParams(location.search).get('page') || 1;
    const navigate = useNavigate()
    const lang = getCookie('HYUNDAILANG')
    const [state, setState] = useState(0)
    const [data, setData] = useState<any>([])
    const [totalCount, setTotalCount] = useState<number>(0)
    const [param, setParam] = useState<ParamType>({lang : lang === 'kr'?'KR':'EN',page : page, size : 10, keyword : '', sortOrder : 'desc', sortColumn : 'question'})
    const [getUserFaqApi] = useGetUserFaqMutation()
    const getList = async() => {
        const result : any = await getUserFaqApi(param)
        if(result.data.result === true){setData(result.data.list); setTotalCount(result.data.total_cnt)}
    }
    const handlePage = (pageNumber : number) => {
        if(page!==pageNumber){navigate(`${location.pathname}?page=${pageNumber}`)}
    }
    useEffect(()=>{
        if(lang === 'kr'){setParam((prev)=>({...prev, lang : 'KR'}))}
        else {setParam((prev)=>({...prev, lang : 'EN'}))}
    }, [lang])
    useEffect(()=>{setParam((prev)=>({...prev, page : page}))}, [page])
    useEffect(()=>{getList()}, [param.lang, param.page])
    return(
        <>
        <div className="contentBox">
            {lang === 'kr' ? 
            <h3>
                <span>추가로 궁금한 점이 있으시다면</span>
                문의하기 페이지 이용을 부탁드립니다.
            </h3>
            :
            <h3>
                <span>If you have any additional questions</span>
                Please use the inquiry page.
            </h3>
            }
            <ul className="faqListBox">
                {data?.map((list:any)=>(
                <li key={list?.faq_idx} onClick={()=>setState(list?.faq_idx)}>
                    <div className="questionBox active">
                        <p>{lang === 'kr' ? list?.faq_question_kr : list?.faq_question_en}</p>
                        <button className="closeBtn">
                            <i className="fa-regular fa-plus"></i>
                        </button>
                    </div>
                    <AnimateHeight duration={500} height={list?.faq_idx === state ? 'auto' : 0}>
                        <div className="answerBox">
                            <p>
                                {lang === 'kr' ? list?.faq_reply_kr : list?.faq_reply_en}
                            </p>
                        </div>
                    </AnimateHeight>

                </li>
                ))}
            </ul>

            <ol className="pager">
                <Paginate page={page} totalCount={totalCount} size={10} setPage={handlePage}/>
            </ol>
        </div>
        </>
    )
}